import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <main className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto space-y-16">

          {/* Terms of Service */}
          <Card>
            <CardContent className="pt-6 space-y-6">
              <h2 className="text-2xl font-bold">Terms of Service</h2>
              <p>
                Welcome to TechG8. By accessing or using our website, you agree to comply with
                the following Terms of Service. Please read them carefully.
              </p>
              <h3 className="text-xl font-semibold">1. Acceptance of Terms</h3>
              <p>
                By using our website, you agree to these Terms of Service and our Privacy Policy
                and Cookie Policy. If you do not agree, please refrain from using the site.
              </p>
              <h3 className="text-xl font-semibold">2. Services</h3>
              <p>
                TechG8 provides IT consultancy, digital transformation, and managed services.
                All services are subject to availability and may change without prior notice.
              </p>
              <h3 className="text-xl font-semibold">3. User Responsibilities</h3>
              <p>
                You are responsible for keeping your account credentials confidential and for
                all activities that occur under your account. You agree not to use the website
                for unlawful or prohibited activities.
              </p>
              <h3 className="text-xl font-semibold">4. Limitation of Liability</h3>
              <p>
                TechG8 is not liable for any indirect, incidental, or consequential damages
                arising from the use of this website or its services. We do not guarantee that
                our website will be error-free or uninterrupted.
              </p>
              <h3 className="text-xl font-semibold">5. Governing Law</h3>
              <p>
                These terms are governed by the laws of Denmark. Any disputes arising from these
                terms shall be resolved in the courts of Denmark.
              </p>
              <h3 className="text-xl font-semibold">6. Contact</h3>
              <p>
                For questions, contact us at:{" "}
                <a href="mailto:info@techg8.com" className="text-primary hover:underline">
                  info@techg8.com
                </a>
              </p>
              <p>© {new Date().getFullYear()} TechG8</p>
            </CardContent>
          </Card>

          {/* Privacy Policy */}
          <Card>
            <CardContent className="pt-6 space-y-6">
              <h2 className="text-2xl font-bold">Privacy Policy</h2>
              <p>
                TechG8 values your privacy and complies with the EU General Data Protection
                Regulation (GDPR). This policy explains how we collect, use, and protect your
                personal data.
              </p>
              <h3 className="text-xl font-semibold">1. Data Controller</h3>
              <p>
                TechG8 <br />
                Email:{" "}
                <a href="mailto:info@techg8.com" className="text-primary hover:underline">
                  info@techg8.com
                </a>
              </p>
              <h3 className="text-xl font-semibold">2. Personal Data We Collect</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Any information you voluntarily provide via contact forms or emails</li>
              </ul>
              <h3 className="text-xl font-semibold">3. Purpose of Data Processing</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Responding to inquiries</li>
                <li>Providing and improving our services</li>
                <li>Fulfilling legal obligations</li>
              </ul>
              <h3 className="text-xl font-semibold">4. Legal Basis for Processing</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Your consent (Article 6(1)(a))</li>
                <li>Performance of a contract (Article 6(1)(b))</li>
                <li>Legitimate interests (Article 6(1)(f))</li>
              </ul>
              <h3 className="text-xl font-semibold">5. Data Sharing</h3>
              <p>
                We do not share your personal data with third parties unless required by law or
                with your explicit consent.
              </p>
              <h3 className="text-xl font-semibold">6. Data Retention</h3>
              <p>
                We retain personal data only for as long as necessary to fulfill the purposes
                outlined in this policy or to comply with legal obligations.
              </p>
              <h3 className="text-xl font-semibold">7. Your Rights Under GDPR</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Access your personal data</li>
                <li>Request correction or deletion</li>
                <li>Restrict or object to processing</li>
                <li>Data portability</li>
                <li>Withdraw consent at any time</li>
              </ul>
              <p>
                To exercise these rights, contact us at{" "}
                <a href="mailto:info@techg8.com" className="text-primary hover:underline">
                  info@techg8.com
                </a>
                .
              </p>
              <h3 className="text-xl font-semibold">8. Security</h3>
              <p>
                We implement appropriate technical and organizational measures to protect your
                data. However, no online system is entirely secure.
              </p>
              <h3 className="text-xl font-semibold">9. Complaints</h3>
              <p>
                You may file a complaint with the Danish Data Protection Agency (Datatilsynet)
                if you believe your rights under GDPR have been violated.
              </p>
              <h3 className="text-xl font-semibold">10. Contact</h3>
              <p>
                For questions or concerns, contact:{" "}
                <a href="mailto:info@techg8.com" className="text-primary hover:underline">
                  info@techg8.com
                </a>
              </p>
              <p>© {new Date().getFullYear()} TechG8</p>
            </CardContent>
          </Card>

          {/* Cookie Policy */}
          <Card>
            <CardContent className="pt-6 space-y-6">
              <h2 className="text-2xl font-bold">Cookie Policy</h2>
              <p>
                This Cookie Policy explains how TechG8 uses cookies in compliance with the
                ePrivacy Directive and GDPR.
              </p>
              <h3 className="text-xl font-semibold">1. What Are Cookies?</h3>
              <p>
                Cookies are small text files stored on your device to enhance your browsing
                experience and help us analyze website performance.
              </p>
              <h3 className="text-xl font-semibold">2. Types of Cookies We Use</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>Essential Cookies: Necessary for core website functionality.</li>
                <li>Analytics Cookies: Help us understand user behavior (only set with your consent).</li>
              </ul>
              <h3 className="text-xl font-semibold">3. Legal Basis</h3>
              <p>
                We use cookies based on your consent, except for strictly necessary cookies.
              </p>
              <h3 className="text-xl font-semibold">4. Managing Cookies</h3>
              <p>
                You can manage or disable cookies through your browser settings or via our
                cookie consent banner. Disabling cookies may affect website performance.
              </p>
              <h3 className="text-xl font-semibold">5. Third-Party Cookies</h3>
              <p>
                We may use third-party services that place their own cookies. These services
                are governed by their own privacy policies.
              </p>
              <h3 className="text-xl font-semibold">6. Data Transfers</h3>
              <p>
                If third-party cookies involve data transfers outside the EU/EEA, we ensure
                appropriate safeguards are in place.
              </p>
              <h3 className="text-xl font-semibold">7. Contact</h3>
              <p>
                For questions about our use of cookies, contact:{" "}
                <a href="mailto:info@techg8.com" className="text-primary hover:underline">
                  info@techg8.com
                </a>
              </p>
              <p>© {new Date().getFullYear()} TechG8</p>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
